import * as React from 'react';
import { connect } from 'react-redux';

import * as PersonalCreators from '../../creators/personalInfoMountTab';
import PersonalInformationTable from './PersonalInformationTable';
import LinearProgress from '@material-ui/core/LinearProgress';
import EmptyData from '../../components/EmptyData/EmptyData';
import MapWrapper from '../../components/Map/MapWrapper';

import {
  userInfoData$,
  isFindUserLoading$,
  isShowPersonalTable$,
  isEmptyData$,
} from '../../selectors/findUser';

import State from '../../interfaces/states/State';
import UserInfo from '../../interfaces/UserInfo';

import './style.scss';

interface DispatchProps {
  personalInfoMountTab: () => void;
}

interface OwnProps {
  userInfoData: UserInfo[];
  isLoading: boolean;
  isShowMap: boolean;
  isShowPersonalTable: boolean;
  isEmptyData: boolean;
}

interface Props extends DispatchProps, OwnProps {}

function PersonalInformation (props: Props) {

  React.useEffect(() => {
    props.personalInfoMountTab();
  }, []);
  
  const {
    isLoading,
    isShowPersonalTable,
    userInfoData,
    isShowMap,
    isEmptyData,
  } = props;
  
  return(
    <div className='d-flex flex-column personal-info-wrapper'>
      <div className='info-container'>
        {
          !!isLoading
             && <div className='d-flex align-center justify-center'>
               <div className='loader-container w-100' >
                 <LinearProgress color='primary' />
               </div>
             </div>
        }
        {
          !!isShowPersonalTable
            && <PersonalInformationTable userInfoData={userInfoData} />
        }
        {
          isEmptyData
            && <EmptyData
              bigImageForTab
              message='No data found for Personal info' />
        }
        { !!isShowMap && <MapWrapper /> }
      </div>
    </div>
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    userInfoData: userInfoData$(state),
    isLoading: isFindUserLoading$(state),
    isShowMap: state.map.isShowMap,
    isShowPersonalTable: isShowPersonalTable$(state),
    isEmptyData: isEmptyData$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    personalInfoMountTab: dispatchProps.personalInfoMountTab,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    personalInfoMountTab: PersonalCreators.personalInfoMountTab,
  }, mergeProps
)(PersonalInformation);
